import { render, staticRenderFns } from "./ResizeModal.vue?vue&type=template&id=744bebd6&scoped=true"
import script from "./ResizeModal.vue?vue&type=script&lang=js"
export * from "./ResizeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744bebd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744bebd6')) {
      api.createRecord('744bebd6', component.options)
    } else {
      api.reload('744bebd6', component.options)
    }
    module.hot.accept("./ResizeModal.vue?vue&type=template&id=744bebd6&scoped=true", function () {
      api.rerender('744bebd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/ResizeModal.vue"
export default component.exports